/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Label_Bucket_LargeInputs */

const en_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Large Bucket`)
};

const es_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cubo grande`)
};

const de_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Großer Eimer`)
};

const zh_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大桶`)
};

const ar_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سلة كبيرة`)
};

const fr_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grand seau`)
};

const vi_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xô lớn`)
};

const sw_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ndoo Kubwa`)
};

const th_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถังใหญ่`)
};

const bs_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velika kanta`)
};

const ja_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラージバケット`)
};

const ko_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라지 버킷`)
};

const pt_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balde grande`)
};

const it_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cestino grande`)
};

const sv_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stor hink`)
};

const nl_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grote emmer`)
};

const da_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stor kurv`)
};

const nb_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stor kurv`)
};

const fi_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iso ämpäri`)
};

const pl_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duży koszyk`)
};

const ru_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Большая корзина`)
};

const tr_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Büyük Kova`)
};

const hi_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बड़ी बाल्टी`)
};

const id_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ember Besar`)
};

const ms_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baldi Besar`)
};

const cs_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velký košík`)
};

const el_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μεγάλος κουβάς`)
};

const he_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דלי גדול`)
};

const af_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groot emmer`)
};

const hu_prices_label_bucket_large = /** @type {(inputs: Prices_Label_Bucket_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagy vödör`)
};

/**
* | output |
* | --- |
* | "Large Bucket" |
*
* @param {Prices_Label_Bucket_LargeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_label_bucket_large = /** @type {((inputs?: Prices_Label_Bucket_LargeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Label_Bucket_LargeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_label_bucket_large(inputs)
	if (locale === "de") return de_prices_label_bucket_large(inputs)
	if (locale === "zh") return zh_prices_label_bucket_large(inputs)
	if (locale === "ar") return ar_prices_label_bucket_large(inputs)
	if (locale === "fr") return fr_prices_label_bucket_large(inputs)
	if (locale === "vi") return vi_prices_label_bucket_large(inputs)
	if (locale === "sw") return sw_prices_label_bucket_large(inputs)
	if (locale === "th") return th_prices_label_bucket_large(inputs)
	if (locale === "bs") return bs_prices_label_bucket_large(inputs)
	if (locale === "ja") return ja_prices_label_bucket_large(inputs)
	if (locale === "ko") return ko_prices_label_bucket_large(inputs)
	if (locale === "pt") return pt_prices_label_bucket_large(inputs)
	if (locale === "it") return it_prices_label_bucket_large(inputs)
	if (locale === "sv") return sv_prices_label_bucket_large(inputs)
	if (locale === "nl") return nl_prices_label_bucket_large(inputs)
	if (locale === "da") return da_prices_label_bucket_large(inputs)
	if (locale === "nb") return nb_prices_label_bucket_large(inputs)
	if (locale === "fi") return fi_prices_label_bucket_large(inputs)
	if (locale === "pl") return pl_prices_label_bucket_large(inputs)
	if (locale === "ru") return ru_prices_label_bucket_large(inputs)
	if (locale === "tr") return tr_prices_label_bucket_large(inputs)
	if (locale === "hi") return hi_prices_label_bucket_large(inputs)
	if (locale === "id") return id_prices_label_bucket_large(inputs)
	if (locale === "ms") return ms_prices_label_bucket_large(inputs)
	if (locale === "cs") return cs_prices_label_bucket_large(inputs)
	if (locale === "el") return el_prices_label_bucket_large(inputs)
	if (locale === "he") return he_prices_label_bucket_large(inputs)
	if (locale === "af") return af_prices_label_bucket_large(inputs)
	if (locale === "hu") return hu_prices_label_bucket_large(inputs)
	return en_prices_label_bucket_large(inputs)
});